
import { Component, Vue, Prop } from 'vue-property-decorator';
import CardOrdineMTM from './CardOrdineMTM.vue';
import { OrdineMTMTestata} from '@/models';

@Component({
  components: { 
      CardOrdineMTM 
    }
})
export default class OrdiniMTMCards extends Vue {
    @Prop() private ordini!: OrdineMTMTestata[];
    @Prop({ default: false }) private compact!: boolean;
}
